import { render } from "./dateGeneral.vue?vue&type=template&id=4311df9a"
import script from "./dateGeneral.vue?vue&type=script&lang=js"
export * from "./dateGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__